import { Box, SxProps, Theme } from '@mui/material';
import { FormCheckbox } from 'components/forms';
import { IEditDeviationFormChildrenProps } from 'pages/managePricing/editDeviationForm';
import { useEffect } from 'react';
import { add48HoursToDate, oneYearAheadToCurrentDate } from 'shared/utility';
import { IAddDeviationFormChildrenProps } from './AddDeviationForm';

const boxStyles: SxProps<Theme> = {
    gridColumn: 5,
    display: 'flex',
    alignItems: 'center',
};

export function OneTimeOnly({ index, control, watch, setValue }: IAddDeviationFormChildrenProps) {
    const name = `addedDeviations.${index}.deviationDetails.isOneTimeOnly` as `addedDeviations.${number}.deviationDetails.isOneTimeOnly`;
    const checkboxValue = watch ? watch(name) : false;

    const effectiveDateName =
        `addedDeviations.${index}.modelCurrentPrice.startdate` as `addedDeviations.${number}.modelCurrentPrice.startdate`;
    const effectiveDateValue = watch ? watch(effectiveDateName) : '';

    const expirationDateName =
        `addedDeviations.${index}.modelCurrentPrice.enddate` as `addedDeviations.${number}.modelCurrentPrice.enddate`;

    useEffect(() => {
        if (checkboxValue && setValue) {
            setValue(expirationDateName, add48HoursToDate(effectiveDateValue));
        }
        else if ((checkboxValue === false) && setValue) {
            setValue(expirationDateName, oneYearAheadToCurrentDate());
        }
    }, [expirationDateName, effectiveDateValue, checkboxValue, setValue]);

    return (
        <Box sx={boxStyles}>
            <FormCheckbox name={name} label='One Time Only' control={control} />
        </Box>
    );
}

export function EditDeviationOneTimeOnly({ control, watch, setValue }: IEditDeviationFormChildrenProps) {
    const name = `deviationDetails.isOneTimeOnly`;
    const checkboxValue = watch ? watch(name) : false;

    const effectiveDateName = `modelCurrentPrice.startdate`;
    const effectiveDateValue = watch ? watch(effectiveDateName) : '';

    const expirationDateName = `modelCurrentPrice.enddate`;

    useEffect(() => {
        if (checkboxValue && setValue) {
            setValue(expirationDateName, add48HoursToDate(effectiveDateValue));
        }
        else if ((checkboxValue === false) && setValue) {
            setValue(expirationDateName, oneYearAheadToCurrentDate());
        }
    }, [expirationDateName, effectiveDateValue, checkboxValue, setValue]);

    return (
        <Box sx={boxStyles}>
            <FormCheckbox name={name} label='One Time Only' control={control} />
        </Box>
    );
}
